import React from 'react';
import { useTranslation } from 'react-i18next';
import { THEME_OPTIONS, useTheme } from '../../contexts/ThemeContext';

const THEME_ICONS = {
  light: (
    <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 3v1.5M12 19.5V21M4.22 4.22l1.06 1.06M18.72 18.72l1.06 1.06M3 12h1.5M19.5 12H21M4.22 19.78l1.06-1.06M18.72 5.28l1.06-1.06M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"
      />
    </svg>
  ),
  dark: (
    <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
      />
    </svg>
  ),
  system: (
    <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.75 17h4.5M8 21h8M6.75 3h10.5A1.75 1.75 0 0119 4.75v8.5A1.75 1.75 0 0117.25 15H6.75A1.75 1.75 0 015 13.25v-8.5A1.75 1.75 0 016.75 3z"
      />
    </svg>
  ),
};

function optionButtonClass(selected) {
  return `flex items-center gap-3 rounded-full border px-4 py-3 text-left text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
    selected
      ? 'border-accent bg-accent text-accent-foreground shadow-sm'
      : 'border-edge bg-surface text-ink-muted hover:border-edge-strong hover:bg-surface-muted'
  }`;
}

/**
 * Settings-panel theme control (light / dark / system).
 * Parent supplies section title/description (Edit Profile → Settings).
 */
const ThemeToggle = () => {
  const { t } = useTranslation();
  const { preference, setPreference } = useTheme();

  return (
    <div
      className="grid gap-2 sm:grid-cols-3"
      role="radiogroup"
      aria-label={t('common.theme')}
    >
      {THEME_OPTIONS.map((option) => {
        const selected = preference === option;
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => setPreference(option)}
            className={optionButtonClass(selected)}
          >
            <span className={selected ? 'text-accent-foreground' : 'text-ink-subtle'}>
              {THEME_ICONS[option]}
            </span>
            <span>{t(`common.${option}`)}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ThemeToggle;
